import { getCookie } from "./cookie";

// The Google Analytics loading function
export default function loadGoogleAnalytics() {
  if (typeof document === "undefined") return; // SSR safety
  
  const consent = getCookie("korrero_cookie_consent");
  if (!consent) {
    return;
  }
  // Check if the script has already been added to prevent duplicates
  if (document.getElementById("google-analytics-script")) return;

  const gaScript = document.createElement("script");
  gaScript.id = "google-analytics-script";
  gaScript.async = true;
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${
    process.env.NEXT_PUBLIC_GA_ID
  }`;

  const inlineScript = document.createElement("script");
  inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${
          process.env.NEXT_PUBLIC_GA_ID
        }');
    `;

  document.head.appendChild(gaScript);
  document.head.appendChild(inlineScript);
}
